import { MessageCircle } from "lucide-react";
import { CONTACT } from "../i18n/translations";

const WhatsAppButton = () => {
  return (
    <a
      data-testid="whatsapp-fab"
      href={CONTACT.whatsapp_link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 group-hover:opacity-60 blur-xl transition-opacity" />
      <span className="relative inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 hover:scale-105 transition-transform">
        <MessageCircle className="w-6 h-6" />
      </span>
    </a>
  );
};

export default WhatsAppButton;
